/**
 * Parses a JSON Web Token (JWT) and returns its payload.
 *
 * @param token - The JWT to parse.
 * @returns An object representing the JWT payload.
 */
export const parseJwt = (token: string) => {
  // Split the token into its three parts: header, payload, and signature
  const base64Url = token.split('.')[1];

  // Decode the Base64URL-encoded payload
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );

  // Parse the payload as a JSON object
  const parsedToken = JSON.parse(jsonPayload);

  // If the "custom:proPermissions" field exists, parse it as a JSON object
  if (parsedToken['custom:proPermissions']) {
    parsedToken['custom:proPermissions'] = JSON.parse(
      parsedToken['custom:proPermissions'],
    );
  }

  return parsedToken;
};
